import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 6.35839V5.07143"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 17.9286V16.6478"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.3647 8.80008C15.3647 7.47927 14.2804 6.35722 12.0004 6.35722C9.7204 6.35722 8.63611 7.41402 8.63611 8.80008C8.63611 9.88024 9.7204 10.9172 12.0004 11.2429C14.2804 11.5687 15.879 12.3204 15.879 13.9481C15.879 15.4129 14.2804 16.6429 12.0004 16.6429C9.7204 16.6429 8.12183 15.5956 8.12183 14.2001"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9999 21.9464C18.6856 21.9464 22.4463 18.1857 22.4463 11.5C22.4463 4.81429 18.6856 1.05357 11.9999 1.05357C5.31418 1.05357 1.55347 4.81429 1.55347 11.5C1.55347 18.1857 5.31418 21.9464 11.9999 21.9464Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
) as React.FC;
